var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 6.23725C14.3333 4.84824 13.7714 3.51613 12.7712 2.53395C11.771 1.55178 10.4145 1 9 1C7.58551 1 6.22896 1.55178 5.22876 2.53395C4.22857 3.51613 3.66667 4.84824 3.66667 6.23725C3.66667 12.3474 1 14.0931 1 14.0931H17C17 14.0931 14.3333 12.3474 14.3333 6.23725Z",
    fill: "#F54F59",
    stroke: "#F54F59",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3678 17.5845C10.2144 17.849 9.9941 18.0686 9.72907 18.2213C9.46405 18.3739 9.16358 18.4543 8.85774 18.4543C8.5519 18.4543 8.25143 18.3739 7.98641 18.2213C7.72139 18.0686 7.50112 17.849 7.34766 17.5845",
    fill: "#F54F59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3678 17.5845C10.2144 17.849 9.9941 18.0686 9.72907 18.2213C9.46405 18.3739 9.16358 18.4543 8.85774 18.4543C8.5519 18.4543 8.25143 18.3739 7.98641 18.2213C7.72139 18.0686 7.50112 17.849 7.34766 17.5845",
    stroke: "#F54F59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.30cc4fac035ca7784fbcf06212b836f7.svg";
export { ForwardRef as ReactComponent };